import React, { useEffect, useState } from 'react';
import { Form, Card, Space, Input, message } from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { getAllSample, printSamplingPdf } from '../../redux/slice';
import CustomTable from 'common/Content/CustomTable';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import Layout from '@/common/Layout';
import { getLoggedInUser } from 'utilities/helpers';
import moment from 'moment';

const { Search } = Input;

const SamplingList = ({ loading }) => {
  const [form] = Form.useForm();
  const { user } = getLoggedInUser();

  const { allSamples } = useSelector((state) => state.stocks);
  const [allsamples, setAllsamples] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [search, setSearch] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [allowedBatchNumber, setAllowedBatchNumber] = useState(null);
  const [printLoading, setPrintLoading] = useState(false);
  console.log(allsamples);
  const dispatch = useDispatch();
  useEffect(() => {
    handleGetAllSampleDetails();
  }, [page, search, pageSize]);

  const handleGetAllSampleDetails = () => {
    const payload = {
      all: true,
      page: page,
      per_page: pageSize,
      search: search
    };
    dispatch(getAllSample(payload)).then((response) => {
      if (response?.payload?.success) {
        setAllsamples(response?.payload?.data);
        setPagination(response?.payload?.pagination);
      }
    });
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const handlePrint = () => {
    // Use all selected containers across all pages
    if (!selectedRowKeys.length) {
      message.warning(
        'Please select at least one warehouse container to print'
      );
      return;
    }

    const payload = { ids: selectedRowKeys };
    setPrintLoading(true);
    dispatch(printSamplingPdf(payload)).then((response) => {
      setPrintLoading(false);
      if (response?.payload?.success) {
        const pdfUrl = response?.payload?.data;

        if (pdfUrl) {
          // Check if it's a full URL or just a blob name
          // if (pdfUrl.startsWith('http')) {
          //   window.open(pdfUrl, '_blank');
          // } else {
          // If it's a blob name, construct the full URL
          window.open(
            `${
              process.env.REACT_APP_STORAGE_URL ||
              'https://graviti-mir-api.lexyslabs.com/api/v1/user/fetch_file?blobName='
            }${pdfUrl.split('/').pop()}`,
            '_blank'
          );
          // }
          message.success('PDF generated successfully');
        } else {
          message.error('PDF URL not found in response');
        }
      } else {
        message.error(response?.payload?.message || 'Failed to generate PDF');
      }
    });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      // If everything is unchecked, reset constraints
      if (!newSelectedRowKeys.length) {
        setSelectedRowKeys([]);
        setAllowedBatchNumber(null);
        return;
      }

      const firstSelectedRow = selectedRows[0];
      if (!firstSelectedRow) {
        setSelectedRowKeys(newSelectedRowKeys);
        return;
      }

      // Determine which batch number is allowed
      const currentBatchNumber =
        allowedBatchNumber ||
        firstSelectedRow?.container?.batch_detail?.inhouse_batch_number;

      if (allowedBatchNumber === null) {
        setAllowedBatchNumber(currentBatchNumber);
      }

      // Only keep rows that belong to the same batch
      const filteredKeys = [];
      selectedRows.forEach((row) => {
        const rowBatch =
          row?.container?.batch_detail?.inhouse_batch_number || null;
        if (rowBatch === currentBatchNumber && row.id) {
          filteredKeys.push(row.id);
        }
      });

      setSelectedRowKeys(filteredKeys);
    },
    getCheckboxProps: (record) => {
      const recordBatch =
        record?.container?.batch_detail?.inhouse_batch_number || null;

      return {
        // Once a batch is chosen, disable checkboxes from other batches
        disabled:
          allowedBatchNumber !== null && recordBatch !== allowedBatchNumber
      };
    },
    // Keep selections when switching pages
    preserveSelectedRowKeys: true
  };

  console.log(allSamples);
  const columns = [
    {
      title: 'Warehouse Container',
      dataIndex: 'warehouse_container',
      key: 'warehouse_container',
      ellipsis: true,
      width: '150px',
      render: (_, record) => {
        return (
          (record?.status !== 'approved' && user?.level == 3 ? (
            <a href={`/sampling?id=${record?.id}`}>
              {record?.container?.number}
            </a>
          ) : (
            record?.container?.number
          )) || 'NA'
        );
      }
    },
    // {
    //   title: 'AR Number',
    //   dataIndex: 'ar_number',
    //   key: 'ar_number',
    //   ellipsis: true,
    //   width: '100px'
    // },
    {
      title: 'Material Code',
      dataIndex: 'material_code',
      key: 'material_code',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.container?.batch_detail?.material?.code
          ? record?.container?.batch_detail?.material?.code
          : 'NA';
      }
    },
    {
      title: 'Material Name',
      dataIndex: 'inhouse_batch_number',
      key: 'inhouse_batch_number',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.container?.batch_detail?.material?.name
          ? record?.container?.batch_detail?.material?.name
          : 'NA';
      }
    },
    {
      title: 'Batch Number',
      dataIndex: 'inhouse_batch_number',
      key: 'inhouse_batch_number',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.container?.batch_detail?.inhouse_batch_number
          ? record?.container?.batch_detail?.inhouse_batch_number
          : 'NA';
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.quantity
          ? `${parseFloat(
              record?.uom == `No.'s`
                ? record?.quantity
                : record?.quantity * 1000
            ).toFixed(3)} ${record?.uom || ''}`
          : 'NA';
      }
    },
    {
      title: 'Sampling Date',
      dataIndex: 'sampling_date',
      key: 'sampling_date',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.sampling_date
          ? moment(record?.sampling_date).format('DD MMM YYYY')
          : 'NA';
      }
    }
  ];

  return (
    <>
      <Layout sider={false}>
        <Form form={form} layout="vertical">
          <Card
            title={<span>Sampling Details</span>}
            className={`${styles.cardStyles_approver}`}
            extra={
              <Space>
                <Search
                  onChange={(e) => handleChange(e)}
                  className={`w-100 ${styles.searchbar}`}
                  justify="start"
                  align="start"
                  placeholder="Search by Batch Number"
                />
                <CustomButton
                  className={styles.inwardButton}
                  onClick={() => history.push('/sampling')}
                  type="primary"
                >
                  Create
                </CustomButton>
              </Space>
            }
          >
            <div className={`${styles.table_container}`}>
              <CustomTable
                showPaginationMeta
                rowSelection={rowSelection}
                rowKey="id"
                columns={columns}
                pagination={{
                  size: 'small',
                  total: pagination?.total_records || 0,
                  pageSize: pageSize,
                  current: page,
                  onChange: (newPage, newSize) => {
                    setPage(newPage);
                    setPageSize(newSize);
                  }
                }}
                dataSource={allsamples}
                loading={loading}
              />
            </div>
          </Card>
          <br />
          <FormItem className="text-center">
            <Space>
              <CustomButton
                className={styles.inwardButton}
                onClick={handlePrint}
                type="primary"
                loading={printLoading}
                disabled={selectedRowKeys.length === 0 || printLoading}
              >
                Print
              </CustomButton>
              <CustomButton
                className={styles.inwardButton}
                onClick={() => history.back()}
                type="primary"
              >
                Back to Home
              </CustomButton>
            </Space>
          </FormItem>
        </Form>
      </Layout>
    </>
  );
};
export default SamplingList;
